/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { useQuery, gql } from '@apollo/client';
import { useTokenContext } from "@exo/frontend-common-app-identity-and-access";

export const usePooledAccount = () => {
  // const tokenContext = useTokenContext();
  // tokenContext.ensureValidToken();
  
  const POOLEDACCOUNT_GQL = gql`
  query PooledAccountOverview {
    pooledAccountOverview {
    pooledAccountDetailsError
      accounts {
        pooledAccountNumber
        accountId
        accountStatus
        correspondenceVariant
        createdDate
      }
    }
  }
  `;

  const { data, loading, error } = useQuery(POOLEDACCOUNT_GQL,{
     context:{
            clientName:"/secure-storage/manage"
        }
  });
  return { data, loading, error };
};
